import { useState } from 'react'

import Divider from '@mui/material/Divider'
import Tab from '@mui/material/Tab'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Tabs from '@mui/material/Tabs'

import type { GeblokkeerdeWeek } from '../types/GeblokkeerdeWeek'

import { GeblokkeerdeWeekTableRow } from './GeblokkeerdeWeekTableRow'

export { GebiedPlanningByYear }

type Props = {
  planning: GeblokkeerdeWeek[]
  onRemove: (geblokkeerdeWeek: GeblokkeerdeWeek) => void
}

const headerCells = [
  { id: 'organisatie', label: 'Projectverantwoordelijke', sort: true },
  { id: 'week', label: 'Week', sort: true },
  { id: 'actions', label: 'Acties' },
] as const

const GebiedPlanningByYear = ({ planning, onRemove }: Props) => {
  const years = {
    all: new Set(planning.map((week) => week.week.split('-')[0])),
    current: new Date().getFullYear().toString(),
  }

  const [year, setYear] = useState(
    years.all.has(years.current) ? years.current : [...years.all][0],
  )

  const tabs = [...years.all].sort((a, b) => a.localeCompare(b))
  const rows = planning
    .filter((week) => week.week.indexOf(year) !== -1)
    .sort((a, b) => a.week.localeCompare(b.week))

  return (
    <>
      <Tabs value={year} onChange={(_, newYear) => setYear(newYear)}>
        {tabs.map((tab) => (
          <Tab key={tab} label={tab} value={tab} />
        ))}
      </Tabs>
      <Divider />

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headerCells.map((headerCell) => (
                <TableCell key={headerCell.id}>{headerCell.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((week) => (
              <GeblokkeerdeWeekTableRow
                key={week.week + week.organisatie}
                geblokkeerdeWeek={week}
                onRemove={onRemove}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
